"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.emitOrcadNetProperties = emitOrcadNetProperties;
function emitOrcadNetProperties(project, groups, report) {
    for (const group of groups) {
        const values = new Map();
        const connections = new Map();
        for (const nets of group.getNets().values()) {
            for (const net of nets) {
                const properties = [
                    ...net.wires.flatMap((wire) => wire.strategyMetadata?.['net-properties'] ?? []),
                    ...net.connections.flatMap((entry) => entry.connection.appliesNetName?.strategyMetadata?.['net-properties'] ?? []),
                ];
                for (const { name, value } of properties) {
                    const entries = values.get(name) ?? new Set();
                    entries.add(value);
                    values.set(name, entries);
                }
                for (const { connection } of net.connections) {
                    const pins = connections.get(connection.moduleRef) ?? new Set();
                    pins.add(connection.pinRef);
                    connections.set(connection.moduleRef, pins);
                }
            }
        }
        if (values.size === 0) {
            continue;
        }
        const properties = {};
        for (const [name, entries] of values) {
            const [value] = entries;
            if (entries.size !== 1 || value === undefined) {
                report(`[net-property-conflict] net=${JSON.stringify(group.physicalName)} property=${JSON.stringify(name)} values=${JSON.stringify([...entries])}`);
            }
            else {
                properties[name] = value;
            }
        }
        const targets = [];
        for (const net of Object.values(project.designs).flatMap((sheet) => Object.values(sheet.nets))) {
            if (net.name !== group.physicalName ||
                !net.connections.some((connection) => connections.get(connection.moduleRef)?.has(connection.pinRef))) {
                continue;
            }
            targets.push(net);
        }
        const global = group.physicalName ? project.globalNets[group.physicalName] : undefined;
        if (targets.length > 0 && global) {
            targets.push(global);
        }
        for (const net of targets) {
            for (const [name, value] of Object.entries(properties)) {
                const existing = net.metadata?.[name];
                if (existing !== undefined && existing !== value) {
                    report(`[net-property-conflict] net=${JSON.stringify(net.name)} property=${JSON.stringify(name)} existing=${JSON.stringify(existing)} recorded=${JSON.stringify(value)}`);
                    continue;
                }
                net.metadata = { ...net.metadata, [name]: value };
            }
        }
    }
}
//# sourceMappingURL=OrcadNetProperties.js.map